/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:58.31
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveVacancyPeriodInfo,
	getVacancyPeriodInfoCreateInit,
	getVacancyPeriodInfoEditInit,
	getVacancyPeriodInfoView,
	deleteVacancyPeriodInfo
} from '@api/lcf/VacancyPeriodInfo';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getVacancyPeriodInfoCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getVacancyPeriodInfoCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getVacancyPeriodInfoEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getVacancyPeriodInfoEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveVacancyPeriodInfo({}, VacancyPeriodInfo) {
			return new Promise((resolve, reject) => {
				saveVacancyPeriodInfo(VacancyPeriodInfo)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getVacancyPeriodInfoView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getVacancyPeriodInfoView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteVacancyPeriodInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteVacancyPeriodInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
